export interface IAvatarProps {
  userName?: string;
  size?: EAvatarSize;
  className?: string;
  url?: string;
}

export enum EAvatarSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
